import { TFunction } from "i18next";

export const getShareColumns = (t: TFunction) => [
  {
    title: t('Analytics.share.entityname'),
    dataIndex: 'entityname',
    key: 'entityname',
    width: 150,
    // sorter: (a: any, b: any) => a.entityname.localeCompare(b.entityname),
  },
  {
    title: t('Analytics.share.sender'),
    dataIndex: 'sender',
    key: 'sender',
    width: 120,
    // sorter: (a: any, b: any) => a.sender.localeCompare(b.sender),
  },
  {
    title: t('Analytics.share.recipient'),
    dataIndex: 'recipient',
    key: 'recipient',
    width: 120,
    // sorter: (a: any, b: any) => a.recipient.localeCompare(b.recipient),
  },
  {
    title: t('Analytics.share.viewed'),
    dataIndex: 'viewed',
    key: 'viewed',
    width: 100,
    sorter: (a: any, b: any) => (a.viewed || 0) - (b.viewed || 1) ,
  },
  {
    title: t('Analytics.share.downloaded'),
    dataIndex: 'downloaded',
    key: 'downloaded',
    width: 100,
    sorter: (a: any, b: any) => (a.downloaded || 0) - (b.downloaded || 1) ,
  },
];


